<template>
  <div class="act">
    <!-- <img 
      src="@/assets/GuangzhouUnicomImg/new2/bg.png"
      class="act-bg"
      alt=""
    />
     -->
     <LogoHeader 
      :logoPath="require('@/assets/logo/elm/elm-mobile.png')"
      altText="中国移动Logo"
    />
    <img
      class="queryBtn"
      src="@/assets/GuangzhouUnicomImg/queryBtn.png"
      alt=""
      @click="queryOrder"
    />
    <img
      class="kefuBtn"
      src="@/assets/GuangzhouUnicomImg/service.png"
      alt=""
      @click="openKefu"
    />
    <div class="bottomBtn" v-show="bottomBtn">
      <img
        @click="onSubmit"
        class="bottomBtnImg"
        src="@/assets/btn/submit_next_button.png"
        alt=""
      />
    </div>
    <div class="content">
      <img src="@/assets/ydtop.png" class="topImg" alt="" />
      <div class="contentBox1">
        <div class="container" v-if="false">
          <div class="header2">重要提醒</div>
          <div class="content">
            <p class="textIndent highlight">
              请保管好自己的身份证、手机卡，不要出租、出借、出售给他人。根据《中华人民共和国刑法》规定，对明知他人利用信息网络实施犯罪而提供帮助，情节严重的，处三年以下有期徒刑或拘役，并处或单处罚金。
            </p>
          </div>
        </div>
        <div class="container">
          <div class="header">套餐内容</div>
          
          <div class="content">
            <div class="zfxqTable3">
              <table style="width:100%;border-collapse:collapse;">
                <tr>
                  <th class="zTh">套餐月租</th>
                  <td class="zTd "><strong class="blueText">49元/月</strong></td>
                  <td class="zTd"><strong class="blueText">69元/月</strong></td>
                </tr>
                <tr>
                  <th class="zTh">套餐说明</th>
                  <td class="zTd left">
                    <strong class="blueText">2500分钟</strong>语音通话<br>
                    <strong class="blueText">70GB</strong>流量<br />
                    <span class="small"><span style="padding-left: 10px;">40G通用流量</span><br/><span style="padding-left: 10px;">30G定向APP流量</span></span><br>
                    <strong class="blueText">200条短信</strong>（不含彩信）
                  </td>
                  <td class="zTd left">
                    <strong class="blueText">3500分钟</strong>语音通话<br>
                    <strong class="blueText">110GB</strong>流量<br />
                    <span class="small"><span style="padding-left: 10px;">80G通用流量</span><br/><span style="padding-left: 10px;">30G定向APP流量</span></span><br>
                    <strong class="blueText">300条短信</strong>（不含彩信）
                  </td>
                </tr>

                <tr>
                  <th class="zTh">优惠说明</th>
                  <td class="zTd"><span class="tipText">套餐价69元，优惠期内为49元。40G国内通用流量中，20G为赠送的套外流量。2500分钟国内主叫通话中，1500分钟为赠送的套外通话。优惠期24个月。</span></td>
                  <td class="zTd"><span class="tipText">套餐价99元，优惠期内为69元。80G国内通用流量中，40G为赠送的套外流量。3500分钟国内主叫通话中，2000分钟为赠送的套外通话。优惠期24个月。</span></td>
                </tr>
                <tr>
                  <th class="zTh">优惠期</th>
                  <td class="zTd">24个月</td>
                  <td class="zTd">24个月</td>
                </tr>
                <tr>
                  <th class="zTh">套餐外资费</th>
                  <td class="zTd left">
                    <strong>国内主叫：</strong>0.1元/分钟<br>
                    <strong>短信：</strong>0.1元/条<br>
                    <strong>彩信：</strong>0.3元/条<br>
                    <strong>流量：</strong>5元/GB
                  </td>
                  <td class="zTd left">
                    <strong>国内主叫：</strong>0.1元/分钟<br>
                    <strong>短信：</strong>0.1元/条<br>
                    <strong>彩信：</strong>0.3元/条<br>
                    <strong>流量：</strong>5元/GB
                  </td>
                </tr>
                <tr>
                  <th class="zTd" colspan="3" style="color: chocolate;">以上资费及权益，离网或变更套餐后自动终止</th>
                </tr>
              </table>
            </div>
          </div>

        </div>
      </div>
      <div class="contentBox2">
        <div class="userInfo">
          <van-form @submit="onSubmit" :label-width="0">
            <div class="form-item">
              <div class="form-label form-label__reqiured">套餐</div>
              <van-field
                class="form-field"
                v-model="comboName"
                name="cardName"
                placeholder="请选择套餐"
                readonly
                @click="showTCBox"
              />
              <van-popup v-model="tcShow" position="bottom">
                <div class="tcBox">
                  <div class="topBox">
                    <!-- <div class="close" @click="closeTC">取消</div>
                    <div class="define" @click="defineTC">确定</div> -->
                    <van-icon name="cross" size="24px" color="#999" @click="closeTC"/>
                  </div>
                  <div class="content">
                    <div
                      :class="['tcItem', { active: index == selIndex }]"
                      v-for="(item, index) in tcList"
                      :key="index"
                      @click="changeTC(index)"
                    >
                      {{ item.name }}
                    </div>
                  </div>
                </div>
              </van-popup>
            </div>
            <div class="form-item">
              <div class="form-label form-label__reqiured">姓名</div>
              <van-field
                class="form-field"
                v-model="cardName"
                name="cardName"
                placeholder="与身份证一致（已加密）"
              />
            </div>
            <div class="form-item">
              <div class="form-label form-label__reqiured">身份证号</div>
              <van-field
                class="form-field"
                v-model="cardNo"
                name="cardNo"
                maxlength="18"
                placeholder="仅用于本次业务（已加密）"
                :rules="[
                  {
                    validator: sfzValidator,
                    message: '请输入正确身份证号码',
                  },
                ]"
              />
            </div>
            <div class="form-item">
              <div class="form-label form-label__reqiured">联系电话</div>
              <van-field
                class="form-field"
                v-model="contactsMobile"
                maxlength="11"
                name="contactsMobile"
                placeholder="收货手机号码（已加密）"
                :rules="[{ pattern, message: '请输入正确手机号码' }]"
              />
            </div>

            <div class="form-item">
              <div class="form-label form-label__reqiured">号码归属地</div>
              <van-field
                readonly
                clickable
                class="form-field"
                name="cardAttribution"
                :value="cardAttribution"
                placeholder="请选择归属地区省市"
                @click="showPicker = true"
              />
              <van-popup v-model="showPicker" position="bottom">
                <van-picker
                  show-toolbar
                  :columns="areaList2"
                  @confirm="selectCity"
                  @cancel="showPicker = false"
                />
              </van-popup>
            </div>

            <div class="form-item">
              <div class="form-label form-label__reqiured">收货城市</div>
              <van-field
                readonly
                clickable
                class="form-field"
                name="contactsCity"
                :value="contactsCity"
                placeholder="请选择收货省市区"
                @click="showArea = true"
              />
              <van-popup v-model="showArea" position="bottom">
                <van-picker
                  show-toolbar
                  :columns="areaList"
                  @confirm="onConfirm"
                />
              </van-popup>
            </div>

            <div class="form-item">
              <div class="form-label form-label__reqiured">详细地址</div>
              <van-field
                class="form-field"
                v-model="contactsAddress"
                name="contactsAddress"
                placeholder="请输入详细的收货地址"
              />
            </div>

            <div class="form-item" v-if="false">
              <div class="form-label form-label__reqiured">免费选号</div>
              <van-field
                readonly
                clickable
                class="form-field"
                :value="comboMobile"
                name="comboMobile"
                placeholder="请选择号码"
                @click="numGuessSelect()"
              />
              <van-dialog
                v-model="showMobilePicker"
                :showConfirmButton="false"
                class="numDialog"
              >
                <div class="numClose">
                  <van-icon
                    name="close"
                    @click="showMobilePicker = false"
                    size="1.2rem"
                  />
                </div>
                <div class="numBox">
                  <div
                    v-for="item in numList"
                    :key="item"
                    class="numContent"
                    @click="selcetNum(item)"
                  >
                    <span>{{ item }}</span>
                  </div>
                </div>
                <div class="numBtn">
                  <van-button
                    icon="replay"
                    type="default"
                    native-type="button"
                    @click="numGuessSelect()"
                    >换一换</van-button
                  >
                </div>
              </van-dialog>
            </div>
            <div class="form-item" v-if="zpActivety">
              <div class="form-label form-label__reqiured">
                {{ simSpiActivity.giftAttrName }}
              </div>
              <van-field
                v-if="sizeList.length <= 1"
                class="form-field"
                :value="giftInfo"
                name="contactsAddress"
                placeholder="请选择赠品尺码"
              />
              <select
                v-else
                class="selectBox"
                v-model="giftInfo"
                @change="changeSize"
              >
                <option value="" disabled selected>请选择尺码</option>
                <option v-for="(item, index) in sizeList" :key="index">
                  {{ item.name }}
                </option>
              </select>
            </div>
            <div class="activeInfo" v-if="zpActivety">
              <div class="activeLeft">{{ simSpiActivity.tips }}</div>
              <div class="activeRight" @click="openTips">
                活动说明
                <van-icon name="question-o" />
              </div>
            </div>
            <div class="dealText"
              v-if="dealTextList && dealTextList.length > 0"
            >
              <div class="read">
                <van-checkbox v-model="checkDeal" icon-size="16px" />
                我已阅读并同意
                <span
                  class="deal"
                  @click="toUnicomDeal(item.components)"
                  v-for="(item, index) in dealTextList"
                  :key="index"
                  ><span class="xy">《{{ item.name }}》</span>
                  <!-- {{ index == dealTextList.length - 1 ? "" : "、" }} -->
                </span>
              </div>
            </div>
          </van-form>
          <div class="btn" ref="sumitBtm" @click="onSubmit">
            <img
              class="lqBtn"
              src="@/assets/btn/submit_next_button.png"
              alt=""
            />
          </div>
        </div>
      </div>
      <div class="contentBox1">
        <div class="bmInfo">
          <div class="bmTitle">最新报名用户</div>
          <div class="bmContent">
            <vue-seamless-scroll
              class="scroll-content"
              :class-option="classOption"
              :data="winningList"
            >
              <div
                class="bmItem"
                v-for="(item, index) in winningList"
                :key="index"
              >
                <div class="bmItemName">{{ item.name }}</div>
                <div class="bmItemPhone">{{ item.phone }}</div>
                <div class="bmItemTime">{{ item.time }}分钟前</div>
              </div>
            </vue-seamless-scroll>
          </div>
        </div>
        <!-- <div class="tcysInfo">
          <img
            class="tcysImg"
            src="@/assets/GuangzhouUnicomImg/new2/tcys.png"
            alt=""
          />
        </div> -->

        <div class="container">
          <div class="header">详细说明</div>
          <div class="content">
            <div class="section">
              <h3>详细说明：</h3>

              <!-- 
              【江苏省骑士卡49元档】
              套餐每月69元，优惠期24个月内为49元，包含内容为：
              1、流量共70G，其中40G通用流量、30G定向APP流量。40G通用流量中，20G为赠送的套外流量。
              2、语音共2500分钟国内主叫通话，其中，1500分钟为赠送的套外通话。
              3、短信共200条
              4、可享骑士险权益
              【江苏省骑士卡69元档】
              套餐每月99元，优惠期24个月内为69元，包含内容为：
              1、流量共110G，其中80G通用流量、30G定向APP流量。80G通用流量中，40G为赠送的套外流量。
              2、语音共3500分钟国内主叫通话，其中，2000分钟为赠送的套外通话。
              3、短信共300条
              4、可享骑士险权益
              -->
              <p><strong>【江苏省骑士卡49元档】</strong></p>
              <p>套餐每月69元，优惠期24个月内为49元，包含内容为：</p>
              <p class="textIndent">
                1、流量共70G，其中40G通用流量、30G定向APP流量。40G通用流量中，20G为赠送的套外流量。
              </p>
              <p class="textIndent">
                2、语音共2500分钟国内主叫通话，其中，1500分钟为赠送的套外通话。
              </p>
              <p class="textIndent">
                3、短信共200条
              </p>
              <p class="textIndent">
                4、可享骑士险权益
              </p>
              <p>
                <strong>【江苏省骑士卡69元档】</strong>
              </p>
              <p class="textIndent">
                套餐每月99元，优惠期24个月内为69元，包含内容为：
              </p>
              <p class="textIndent">
                1、流量共110G，其中80G通用流量、30G定向APP流量。80G通用流量中，40G为赠送的套外流量。
              </p>
              <p class="textIndent">
                2、语音共3500分钟国内主叫通话，其中，2000分钟为赠送的套外通话。
              </p>
              <p class="textIndent">
                3、短信共300条
              </p>
              <p class="textIndent">
                4、可享骑士险权益
              </p>
            </div>

            
          </div>

        </div>

        <div class="container">
          <div class="header">购买须知</div>
          <div class="content">
            <div class="section">
              <p>
                1、客户下单购买需年满18周岁并且有民事行为能力，同一身份证只能办理1个号码，具体限制时间以号码归属地政策为准。
              </p>
              <p> 2、为了保障通讯秩序，我司有权取消异常订单。如同一用户订购两个或两个以上相同商品的订单，不予发货。同一用户的定义包括但不限于以下情况:同一身份证、或同一联系号码、或同一个收件人(同名除外)、相同(雷同、邻近、虚构、乱码等)的收货地址等。
              </p>
              <p>3、根据国家实名制相关规定，请保证所购号卡为本人使用，不得转售、倒卖号卡。
              </p>
              <p>4、若客户提供的资料不真实或存在其他法律障碍，我司有权随时暂停服务，并解除本协议及本协议有效期内与客户签订的任何协议。
              </p>
              <p>5、根据公安部和工信部要求，新入网客户呼叫转移功能处于关停状态。
              </p>
              <p>6、为保障您的合法权益，购买号卡产品必须由使用者本人亲自签收，并向配送人员出示身份证原件，不支持代收，否则我司有权拒绝交付。
              </p>
              <p>7、配送说明:本产品由合作的快递公司配送，具体派送情况，请以物流信息及配送结果为准，部分地址可能无法配送。
              </p>
              <p>8、号码归属地：江苏省，按选择配送。
               </p>
            </div>
          </div>
        </div>

        <div class="container">
          <div class="header">常见问题</div>
          <div class="content">
            <div class="section">
              <p>1、未满18周岁不能办理新卡入网。</p>
              <p>
                2、请于提交订单15天内激活您的号卡，逾期未能激活的，本订单将自动取消，号卡失效。
              </p>
              <p>
                3、根据工信部要求，您的号卡激活且开通后将由人工对实名照片进行审核，审核不通过的将通过短信方式通知您按要求进行补上传照片操作，逾期若未补上传照片的，号码将被暂停通信服务。
              </p>
              <p>4、50天内已超过3次办理移动号卡拆机业务的用户无法办理此卡。</p>
              <p>5、本套餐不支持副卡。</p>
              <p class="textIndent">套餐条款以页面营销协议为准</p>
              <p>
                6、此卡禁止用于电话销售/推销/金融等类似骚扰诈骗等形式的用途，一旦被投诉或系统监测到会导致停机，无法继续享受优惠或使用。
              </p>
              <p>
                7、产品及相关优惠活动仅限指定互联网渠道销售，产品最终名称以移动系统展示为准。在使用过程中若遇任何问题，可致电18594033399/17502020112客服热线咨询。
              </p>
              <p>8、如需销户，可咨询归属地10086</p>
            </div>
          </div>
        </div>
        <div class="container" v-if="false">
          <img
            class="spiImg"
            src="@/assets/chinamobileImg/yd-hb-img.jpg"
            alt=""
          />
        </div>
      </div>

      <img
        class="bottomImg"
        src="@/assets/GuangzhouUnicomImg/bottomImg.png"
        alt=""
      />
    </div>
    <van-dialog
      v-model="showKefu"
      title="扫码联系客服"
      confirm-button-text="关闭"
      confirm-button-color="#3860cf"
    >
      <div class="kefuBox">
        <!-- <img
          class="kefuQRCode"
          src="@/assets/GuangzhouUnicomImg/new/kefuQRCode.png"
          alt=""
        /> -->
      </div>
    </van-dialog>
    <van-dialog
      v-model="showSetSize"
      title="赠品尺码"
      confirm-button-text="确定"
      confirm-button-color="#3860cf"
      @confirm="confirmSize"
    >
      <div class="sizeBox">
        <div class="sizeBoxList">
          <div
            :class="['sItem', { active: index == sizeIndex }]"
            @click="changeSize(index)"
            v-for="(item, index) in sizeList"
            :key="index"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
    </van-dialog>
    <van-dialog
      v-model="tipsShow"
      confirm-button-text="关闭"
      confirm-button-color="#3860cf"
      @confirm="closeTips"
    >
      <div class="dialogTips">
        <img class="tipsImg" :src="tipsImg" alt="" />
      </div>
    </van-dialog>
    <dialogTips
      :text="dialogTips.text"
      :icon="dialogTips.icon"
      :iconColor="dialogTips.iconColor"
      :show="dialogTips.show"
      :confirmButtonText="dialogTips.confirmButtonText"
      @confirm="confirmTips"
    ></dialogTips>
  </div>
</template>

<script>
import {
  Form,
  Field,
  Popup,
  Picker,
  Dialog,
  Icon,
  Checkbox,
  Button,
} from "vant";
import areaData from "../../public/static/areaData-jiangsu.json";
// import operatorData from "../../public/static/operatorData.json";
import { http } from "@/api/http";
import moment from "moment";
import dialogTips from "@/pages/components/dialogTips";
import LogoHeader from "@/components/LogoHeader.vue";
// import Countdown from "./components/Countdown.vue";
// import { deepClone } from "@/utils/utils";
export default {
  name: "hubeiMobile1",
  components: {
    vanForm: Form,
    vanField: Field,
    vanPopup: Popup,
    vanPicker: Picker,
    vanButton: Button,
    vanIcon: Icon,
    vanCheckbox: Checkbox,
    [Dialog.Component.name]: Dialog.Component,
    dialogTips,
    LogoHeader,
    // Countdown,
  },
  data() {
    return {
      areaList: [],
      comboName: "",
      cardName: "",
      cardNo: "",
      contactsMobile: "",
      cardAttribution: "",
      cardAttributionCode: "",
      comboMobile: "",
      contactsCity: "",
      contactsAddress: "",
      columns: [],
      showArea: false,
      showMobile: "",
      checkDeal: true,
      showPicker: false,
      // mapData: [],
      mtBmUid: "",
      spiId: "",
      cardAttributionProvince: "",
      showMobilePicker: false,
      numList: [],
      pattern: /^1[3456789]\d{9}$/,
      // selectCombo: {},
      goodsCode: null,
      dealTextList: [], //协议数据
      areaData: {},
      areaData2: {}, //号码归属地
      saleId: null,
      scrollY: 0,
      bottomBtn: false,
      showBtnTop: 0,
      oIndex: 0,
      comboData: {},
      channel: "",
      winningList: [
        { name: "张**", phone: "137******3", time: 5 },
        { name: "李**", phone: "138******6", time: 7 },
        { name: "欧阳**", phone: "170******1", time: 7 },
        { name: "陈**", phone: "182******6", time: 9 },
        { name: "林**", phone: "187******3", time: 10 },
        { name: "张**", phone: "153******2", time: 10 },
        { name: "黄**", phone: "138******5", time: 11 },
        { name: "王**", phone: "136******1", time: 12 },
        { name: "李**", phone: "182******7", time: 12 },
        { name: "陈**", phone: "189******8", time: 13 },

        // 更多中奖者...
      ],
      classOption: {
        singleHeight: 40,
        waitTime: 5000,
      },
      showKefu: false,
      endTime: moment("2024/12/25 09:59:59").valueOf(),
      isEnded: false,
      sizeList: [],
      showSetSize: false,
      giftInfo: "",
      sizeIndex: 0,
      zpActivety: false,
      simSpiActivity: null,
      tipsShow: false,
      tipsImg: "",
      dialogTips: {
        text: "",
        icon: "",
        iconColor: "",
        show: false,
        confirmButtonText: "",
      },
      noClick: false,
      goodsName: "",
      selNumTips: "请选择号码",
      tcShow: false,
      selIndex: -1,
      tcList: [
        {
          name: "49元/月2500分钟+70G骑士卡",
          title: "JSYD-ELM49",
          comboCode: "JSYD-ELM49",
          goodsCode: "JSYD-ELM49",
          price: 49,
        },
        {
          name: "69元/月3500分钟+110G骑士卡",
          title: "JSYD-ELM69",
          comboCode: "JSYD-ELM69",
          goodsCode: "JSYD-ELM69",
          price: 69,
        }
      ],
      comboCode: "",
      //号卡归属省市
      cardAreaData: {
        text: "",
        code: "0",
        children: [
          {
            text: "江苏",
            "code": "320000",
            "children": [
              {
                "text": "南京",
                "code": "320100"
              },{
                "text": "淮安",
                "code": "320800"
              }
            ]
          }
        ]
      }
    };
  },
  created() {
    this.mtBmUid = localStorage.getItem("mtBmUid");
    this.spiId = localStorage.getItem("gysCode");
    this.saleId = localStorage.getItem("saleId");
    this.oIndex = localStorage.getItem("oIndex");
    this.channel = localStorage.getItem("channel");
    this.areaList = [];
    this.areaList.push(areaData);
    this.initAreaList2();
    //this.cardAttribution = "南京";
    this.cardAttributionProvince = "320000";
    //this.cardAttributionCode = "320100";
    this.dealTextList = [
      // {
      //   name: "入网协议",
      //   components: "gdydruwangxy",
      //   },
      //   {
      //     name: "用户隐私协议",
      //     components: "gdydyhxsxy",
      //   },
      //   {
      //     name: "电子渠道开户服务协议",
      //     components: "gddzqdkhfwxy",
      //   },{
      //     name: "中国移动广东公司电子渠道商品销售服务协议",
      //     components: "gdyddzqdspxsfwxy",
      //   },{
      //     name: "个人/单位在通信企业申请通讯工具涉电信网络新型违法犯罪法律责任及防范提示告知书",
      //     components: "gdydtxqysqtxgjsdxwlxxwffzflzrjfftsgzs",
      //   },{
      //     name: "中国移动权益超市服务协议",
      //     components: "gdydqycsfwxy",
      //   },{
      //     name: "解约条款",
      //     components: "gdydjytk",
      //   }
    ];
    this.simViewLogAdd();
    if (this.channel == "ELM") {
      this.getActivityBySpi();
    }
  },
  watch: {
    selIndex(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.comboMobile = "";
        this.comboName = this.tcList[newVal].name;
        this.goodsName = this.tcList[newVal].name;
      }
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.$nextTick(() => {
      const height = this.$refs.sumitBtm.offsetTop;
      this.showBtnTop = height + window.innerHeight;
    });
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    changeTC(index) {
      this.selIndex = index;
      this.tcShow = false;
    },
    showTCBox() {
      this.tcShow = true;
    },
  
    closeTC() {
      this.tcShow = false;
    },

    confirmTips() {
      this.dialogTips.show = false;
      this.$forceUpdate();
      if (this.dialogTips.icon == "success") {
        window.location.reload();
      }
    },
    openTips() {
      this.tipsImg = this.simSpiActivity.imgPath;
      // console.log("tipsImg =>",this.tipsImg)
      this.tipsShow = true;
    },
    closeTips() {
      this.tipsShow = false;
    },
    async simViewLogAdd() {
      let params = {
        mtBmUid: this.oIndex,
        spiId: this.spiId,
        clickName: this.oIndex,
        uid: "",
      };
      http("simViewLogAdd", params);
    },
    errorAdd(msg, remark, params) {
      let newParams = {
        mtBmUid: this.oIndex,
        spiId: this.spiId,
        clickName: `ERROR-${this.oIndex}-${msg}`,
        uid: params.contactsMobile,
        remark,
        param: JSON.stringify(params),
      };
      http("simViewLogAdd", newParams);
    },
    confirmSize() {
      this.giftInfo = this.sizeList[this.sizeIndex].value;
    },
    setSize(item) {
      this.giftInfo = item.value;
    },
    changeSize(e) {
      console.log("e =>", e.target.value);
      this.giftInfo = e.target.value;
      // this.sizeIndex = index;
    },
    openSetMeal() {
      this.showSetSize = true;
    },
    ended() {
      this.isEnded = true;
    },
    openKefu() {
      // this.showKefu = true;
      window.location.href =
        "https://work.weixin.qq.com/kfid/kfc2ef46aff0a7d85a6";
    },
    queryOrder() {
      window.location.href = "https://wap.js.10086.cn/HKDDCX.thtml";
      //this.$router.push({ name: 'OrderListLocal', params: { spiId: this.spiId } })
    },
    async getActivityBySpi() {
      let params = {
        spiId: this.spiId,
      };

      const res = await http("getActivityBySpi", params, { hideLoading: true });
      if (res && res.code == 200 && res.result.hasActivity) {
        let list = [];
        let sList = JSON.parse(res.result.simSpiActivity.giftSelectList);
        let obj = null;
        sList.map((v) => {
          for (let key in v) {
            obj = {
              name: key,
              value: v[key],
            };
          }
          list.push(obj);
        });
        if (list.length <= 1) {
          this.giftInfo = list[0].value;
        }
        this.sizeList = list;
        this.simSpiActivity = res.result.simSpiActivity;
        this.zpActivety = true;
        this.tipsImg = res.result.simSpiActivity.imgAlertPath;
        this.tipsShow = true;
      } else {
        this.zpActivety = false;
      }
    },
    async onSubmit(values) {
      this.comboMobile = "random";
      if (this.noClick) {
        return;
      } else if (!this.checkDeal) {
        this.$toast("请阅读并同意协议");
        return;
      } else if (!this.comboName) {
        this.$toast("请选择套餐");
        return;
      } else if (!this.cardName) {
        this.$toast("请填写姓名");
        return;
      } else if (!this.cardNo) {
        this.$toast("请填写身份证号码");
        return;
      } else if (!this.contactsMobile) {
        this.$toast("请填写联系电话");
        return;
      } else if (!this.cardAttribution) {
        this.$toast("请选择号码归属地");
        return;
      }
       else if (!this.comboMobile) {
        this.$toast("请选择号码");
        return;
      }
      else if (!this.contactsCity) {
        this.$toast("请选择收货区地址");
        return;
      } else if (!this.contactsAddress) {
        this.$toast("请输入详细的收货地址");
        return;
      } else if (this.contactsAddress.length < 4) {
        this.$toast("详细地址长度不少于4位");
        return;
      } else if (this.zpActivety && !this.giftInfo) {
        this.$toast("请选择赠品尺码");
        return;
      }

      let params = {
        comboLevel: this.tcList[this.selIndex].price,
        comboName: this.tcList[this.selIndex].name,
        cardAttribution: this.cardAttributionCode,
        goodsName: this.goodsName,
        mtBmUid: this.mtBmUid,
        spiDepartId: this.spiId,
        comboMobile: this.comboMobile,
        cardAttributionProvince:this.cardAttributionProvince,
        contactsProvince: this.areaData.pName, // 省
        contactsProvinceCode: this.areaData.pCode, // 省
        contactsCity: this.areaData.cName, // 市
        contactsCityCode: this.areaData.cCode, // 市
        contactsArea: this.areaData.aName, // 区
        contactsAreaCode: this.areaData.aCode, // 区
        comboCode: this.tcList[this.selIndex].comboCode,
        goodsCode: this.tcList[this.selIndex].goodsCode,
        saleId: this.saleId,
        cardName: this.cardName,
        cardNo: this.cardNo,
        channelCode: "",
        checkCode: "",
        contactsAddress: this.contactsAddress,
        contactsMobile: this.contactsMobile,
        feeType: "",
        numberId: "",
        registerMobile: "",
        tractAddress: "",
        uid: "",
        channel: this.channel,
      };
      // if (this.areaData2.pCode != this.areaData.pCode) {
      //   this.errorAdd("GSDSHDZBYZ", "号码归属省份和收货省份不一致", params);
      //   return this.$toast("号码归属省份需和收货省份一致");
      // }
      if (this.zpActivety) {
        params = {
          ...params,
          giftInfo: this.giftInfo,
        };
      }
      this.noClick = true;
      let paramsData = Object.assign(values, params);
      const { code, message, result } = await http("simOrder", paramsData);
      this.noClick = false;
      if (code == 200) {
        if (result.shortUrl != null && result.shortUrl != "") {
          //跳转到运营商处理
          window.location.href = result.shortUrl;
          return;
        }
        this.dialogTips = {
          text: "提交成功，请留意快递信息，收到的手机号必须与您选择的号码一致，不一致将无法享受套餐相应优惠或活动赠送礼品，如发现号码不一致，请立即联系在线客服处理",
          icon: "success",
          iconColor: "#07C160",
          show: true,
          confirmButtonText: "确定",
        };
        // 提交成功后可选择清理缓存，如需长期保留可注释下一行
        // this.clearFormCache();
      } else {
        this.dialogTips = {
          text: message,
          icon: "warning",
          iconColor: "#FF4444",
          show: true,
          confirmButtonText: "关闭",
        };
      }
    },
    handleScroll() {
      this.scrollY = window.scrollY;
      if (this.scrollY >= this.showBtnTop) {
        if (!this.bottomBtn) {
          this.bottomBtn = true;
        }
      } else {
        if (this.bottomBtn) {
          this.bottomBtn = false;
        }
      }
      // console.log("Scroll Y position:", this.scrollY);
    },
    selcetNum(item) {
      this.comboMobile = item;
      this.showMobilePicker = false;
    },
    selectCity(values, indexs) {
      // console.log("value =>",value)
      // this.cardAttribution = value.text;
      // this.cardAttributionProvince = value.value;

      this.areaData2 = {
        pName:
          indexs.length > 1
            ? this.areaList2[indexs[0]].children[indexs[1]].text
            : "", //省
        pCode:
          indexs.length > 1
            ? this.areaList2[indexs[0]].children[indexs[1]].code
            : "",
        cName:
          indexs.length > 2
            ? this.areaList2[indexs[0]].children[indexs[1]].children[indexs[2]]
                .text
            : "", //市
        cCode:
          indexs.length > 2
            ? this.areaList2[indexs[0]].children[indexs[1]].children[indexs[2]]
                .code
            : "",
      };
      this.cardAttribution = values
        .filter((item) => !!item)
        .map((item) => item)
        .join("");


      this.cardAttributionProvince = this.areaData2.pCode;
      this.cardAttributionCode = this.areaData2.cCode;

      this.showPicker = false;
    },
    onConfirm(values, indexs) {
      this.areaData = {
        pName:
          indexs.length > 1
            ? this.areaList[indexs[0]].children[indexs[1]].text
            : "", //省
        pCode:
          indexs.length > 1
            ? this.areaList[indexs[0]].children[indexs[1]].code
            : "",
        cName:
          indexs.length > 2
            ? this.areaList[indexs[0]].children[indexs[1]].children[indexs[2]]
                .text
            : "", //市
        cCode:
          indexs.length > 2
            ? this.areaList[indexs[0]].children[indexs[1]].children[indexs[2]]
                .code
            : "",
        aName:
          indexs.length > 2
            ? this.areaList[indexs[0]].children[indexs[1]].children[indexs[2]]
                .children[indexs[3]].text
            : "", //区
        aCode:
          indexs.length > 2
            ? this.areaList[indexs[0]].children[indexs[1]].children[indexs[2]]
                .children[indexs[3]].code
            : "",
      };
      console.log("areaData =>", this.areaData);
      this.contactsCity = values
        .filter((item) => !!item)
        .map((item) => item)
        .join("");
      // this.mapData = values;
      this.showArea = false;
    },
    sfzValidator(val) {
      return /^[1-9]\d{5}(19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(
        val
      );
    },

    async numGuessSelect() {
      if (!this.cardName) {
        this.$toast("请填写姓名");
        return;
      } else if (!this.cardNo) {
        this.$toast("请填写身份证号码");
        return;
      } else if (!this.contactsMobile) {
        this.$toast("请填写联系电话");
        return;
      } else if (!this.contactsCity) {
        this.$toast("请选择收货地址");
        return;
      } else if (!this.cardAttribution) {
        this.$toast("请选择号码归属地");
        return;
      }

      let params = {
        spiId: this.spiId,
        cityCode: this.cardAttributionCode,
        goodsId: this.tcList[this.selIndex].comboCode,
        provinceCode: this.cardAttributionProvince,
      };
      const { code, result, message } = await http(
        "simNumGuessSelect",
        params
      );
      if (code !== 200) return this.$toast(message);
      if (code == 200) {
        console.log("result =>", result);
        this.numList = result;
        this.showMobilePicker = true;
      }
    },
    initAreaList2() {
      let pArr = [];
      let cArr = [];
      let pObj = {};
      let cObj = {};
      let areaList = [];
      areaList.push(this.cardAreaData);
      // areaList.push(areaData["c5ae2ee23e66400cac01eff3246498dd2"]);
      areaList.map((v) => {
        v.children.map((val) => {
          cArr = [];
          val.children.map((value) => {
            cObj = {
              text: value.text,
              code: value.code,
            };
            cArr.push(cObj);
          });
          pObj = {
            text: val.text,
            code: val.code,
            children: cArr,
          };
          pArr.push(pObj);
        });
      });
      console.log("pArr =>", pArr);
      this.areaList2 = [
        {
          text: "",
          code: "0",
          children: pArr,
        },
      ];
    },
    toUnicomDeal(components) {
      this.$router.push({
        name: components,
      });
    },
    getCard() {
      const queryData = Object.assign({}, this.swiperMsg, {
        spiId: this.spiId,
        mtBmUid: this.mtBmUid,
      });
      delete queryData.abstractImg;
      this.$router.push({
        name: "GuangzhouUHanding",
        query: queryData,
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../assets/style/GuangzhouUnicom.less";
.textIndent {
  padding-left: 10px;
}

.act {
  .container {
    .content {
      padding: 5px;
      
    }
  }
}

.tcBox {
  padding: 10px 0;
  // padding-bottom: 20px;
  .topBox {
    display: flex;
    justify-content: end;
    align-items: center;
    padding: 0 20px;
    .close {
      color: #969799;
      padding: 15px;
    }
    .define {
      color: #576b95;
      padding: 10px;
    }
    .title {
      font-size: 18px;
      padding: 15px;
    }
  }
  .content {
    .tcItem {
      border-bottom: 1px solid #eee;
      padding: 10px 0;
      font-size: 16px;
      text-align: center;
      box-sizing: border-box;
      &:last-child {
        border: none;
      }
      &.active {
        color: #3074da;
      }
    }
  }
}

.spiImg {
  width: 100%;
  border-radius: 10px;
}





.zfxqTable3 .zTh {
  width: 15%;
  color: #3e5fb2;
  text-align: center;
  font-size: 14px;
  font-weight: bold;
  border-right: 1px solid #799ffd;
  border-bottom: 1px solid #799ffd;
  box-sizing: border-box;
  padding: 8px 10px;
}

.zfxqTable3 .zTh2 {
  width: 20%;
  color: #3e5fb2;
  text-align: center;
  font-size: 12px;
  font-weight: bold;
  border-right: 1px solid #799ffd;
  border-bottom: 1px solid #799ffd;
  box-sizing: border-box;
  padding: 8px 10px;
}

.zfxqTable3 table,
.zfxqTable3 th,
.zfxqTable3 td {
  border: 1px solid #799ffd;
  padding: 4px;
  width: 40%;
}
.zfxqTable3 table {
  border-collapse: collapse;
}

.zfxqTable3 .zTd {
  text-align: center;
  font-size: 14px;
  color: #19191a;
}
.zfxqTable3 .zTd.left {
  text-align: left;
  font-size: 13px;
  color: #19191a;
}
.zfxqTable3 .zTd .blueText {
  color: #3e5fb2;
}
.zfxqTable3 .zTd .small {
  font-size: 12px;
  color: #616060;
}
.zfxqTable3 .zTd .tipText {
  color: chocolate;
  font-size: 12px;
}
</style>
